import { FocusMonitor } from '@angular/cdk/a11y';
import { Component, ElementRef, Input, OnDestroy, OnInit, Optional, Self, ViewEncapsulation } from '@angular/core';
import { FormControl, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomFormField } from '../../abstract/custom-form-field';

@Component({
  selector: 'rezolve-toggle-control',
  templateUrl: './toggle-control.component.html',
  styleUrls: ['./toggle-control.component.scss'],
  providers: [{ provide: MatFormFieldControl, useExisting: ToggleControlComponent }],
  encapsulation: ViewEncapsulation.None,
})
export class ToggleControlComponent extends CustomFormField<boolean> implements OnInit, OnDestroy {
  private destroy$ = new Subject();

  @Input() isSmall = false;
  @Input() description?: string;

  toggleControl: FormControl = new FormControl(false);

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private focusMonitor: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
  ) {
    super(ngControl);
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
    this.focusMonitor
      .monitor(this.elRef, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe((origin) => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    this.componentName = 'toggle-control';
  }

  ngOnInit(): void {
    this.id = `rezolve-${this.componentName}-${ToggleControlComponent.nextId++}`;
    this.controlType = `rezolve-${this.componentName}`;

    if (this.required) {
      this.toggleControl.setValidators(Validators.required);
    }
  }

  ngOnDestroy(): void {
    this.stateChanges.complete();
    this.focusMonitor.stopMonitoring(this.elRef);
    this.destroy$.next();
    this.destroy$.complete();
  }

  setState(value: boolean | null): void {
    this.toggleControl.setValue(value);
  }

  getState(): boolean | null {
    return this.toggleControl.value;
  }

  onValueChange() {
    this.markAsTouched();
    this.onChange(this.value);
  }

  disableControl(disabled: boolean): void {
    disabled ? this.toggleControl.disable() : this.toggleControl.enable();
  }

  get errorState(): boolean {
    return !!this.toggleControl.errors && this.isTouched();
  }
}
